/**
 * @generated SignedSource<<d4350bdfc5474253c570896bd7174382>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type overviewPageQuery$variables = {
  boardId: string;
};
export type overviewPageQuery$data = {
  readonly jira: {
    readonly reportsPage: {
      readonly categories: ReadonlyArray<{
        readonly name: string | null | undefined;
      } | null | undefined>;
    };
  };
};
export type overviewPageQuery = {
  response: overviewPageQuery$data;
  variables: overviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overviewPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "ReportsPage",
                "kind": "LinkedField",
                "name": "reportsPage",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "ReportCategory",
                      "kind": "LinkedField",
                      "name": "categories",
                      "plural": true,
                      "selections": [
                        (v2/*: any*/)
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.reportsPage.categories"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.reportsPage"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overviewPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "ReportsPage",
            "kind": "LinkedField",
            "name": "reportsPage",
            "plural": false,
            "selections": [
              {
                "concreteType": "ReportCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b9efc53d002ed3c238f14b593cbb8072",
    "id": null,
    "metadata": {},
    "name": "overviewPageQuery",
    "operationKind": "query",
    "text": "query overviewPageQuery($boardId:ID!){jira{reportsPage(boardId:$boardId){categories{name,id}}}}"
  }
};
})();

(node as any).hash = "4b6f40bf6ac0c35e3ce84ea12ba8d167";

export default node;
